import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../components/shared/Loader";
import { updateMeta } from "../store/actions/metaAction";

const About = () => {
	const auth = useSelector(state => state.auth.user);
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(true);
	const [allInformation, setAllInformation] = useState([]);
	const [allInformationEn, setAllInformationEn] = useState([]);
	const [infoTitle, setInfoTitle] = useState(null);
	const [infoTitleEn, setInfoTitleEn] = useState(null);
	const [infoDescription, setInfoDescription] = useState(null);
	const [infoDescriptionEn, setInfoDescriptionEn] = useState(null);

	useEffect(() => {
		onStart();
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "الخطوات",
				breadcrumb: "الخطوات",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/posts/114`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setAllInformation(response.data.data.data.steps.ar)
				setAllInformationEn(response.data.data.data.steps.en)
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const pushToInformation = e => {
		e.preventDefault();
		if (allInformation.length >= 4 || allInformation.length >= 4) {
			return toast.error("يجب ان لا يزيد عدد الخطوات عن 4")
		}
		if (infoTitle === "") {
			toast.error("برجاء تعبئة الحقول المطلوبة!");
			return;
		}
		const data = { title: infoTitle, description: infoDescription };
		allInformation.push(data);
		setAllInformation(allInformation);
		setInfoTitle("");
		setInfoDescription("");
	};

	const handleDeleteInfo = (event, information) => {
		event.preventDefault();
		const arr = allInformation.filter(function (item) {
			return item.title !== information.title;
		});
		setAllInformation(arr);
	};

	const pushToInformationEn = e => {
		e.preventDefault();
		if (allInformationEn.length >= 4 || allInformationEn.length >= 4) {
			return toast.error("يجب ان لا يزيد عدد الخطوات عن 4")
		}
		if (infoTitleEn === "") {
			toast.error("برجاء تعبئة الحقول المطلوبة!");
			return;
		}
		const data = { title: infoTitleEn, description: infoDescriptionEn };
		allInformationEn.push(data);
		setAllInformationEn(allInformationEn);
		setInfoTitleEn("");
		setInfoDescriptionEn("");
	};

	const handleDeleteInfoEn = (event, information) => {
		event.preventDefault();
		const arr = allInformationEn.filter(function (item) {
			return item.title !== information.title;
		});
		setAllInformationEn(arr);
	};

	const handleSubmit = async e => {
		e.preventDefault();
		setLoading(true);
		if (allInformation.length < 4 || allInformationEn.length < 4) {
			toast.error("يجب ان لا يقل عدد الخطوات عن 4")
			return setLoading(false);
		}

		const data = {
			steps: {
				ar: allInformation,
				en: allInformationEn
			},
		};
		axios
			.put(
				`${process.env.REACT_APP_API_URL}/posts/114`,
				{
					admin_id: auth.id,
					category_id: 1,
					data: data,
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				toast.success("تم تحديث الخطوات بنجاح!");
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-12">
						<div className="card">
							<div className="card-header">الخطوات بالعربية</div>
							<div className="card-body">
								<div className="row">
									<div className="col-md-12">
										<div className="form-item">
											<div className="row">
												<div className="col-md-12">
													<label htmlFor="question">عنوان الخطوة</label>
													<input
														type="text"
														id="question"
														value={infoTitle}
														onChange={e => setInfoTitle(e.target.value)}
													/>
												</div>
												<div className="col-md-12 mt-4">
													<label htmlFor="question">وصف الخطوة</label>
													<textarea
														id="question"
														value={infoDescription}
														onChange={e => setInfoDescription(e.target.value)}
													/>
												</div>
											</div>
										</div>
										<div className="form-item" />
										<button
											className="bt bt-success"
											onClick={pushToInformation}
										>
											اضافة خطوة
										</button>
										<div className="form-item" style={{ marginTop: "40px" }}>
											<ul className="list-unstyled pointList">
												{allInformation.map(feature => (
													<li key={feature.title}>
														<button onClick={e => handleDeleteInfo(e, feature)}>
															<i className="fas fa-trash" />
														</button>
														<span>
															<strong>{feature.title}</strong> -{" "}
															{feature.description}
														</span>
													</li>
												))}
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="card mt-5">
							<div className="card-header">الخطوات بالانجليزية</div>
							<div className="card-body">
								<div className="row">
									<div className="col-md-12">
										<div className="form-item">
											<div className="row">
												<div className="col-md-12">
													<label htmlFor="question">عنوان الخطوة</label>
													<input
														type="text"
														id="question"
														value={infoTitleEn}
														onChange={e => setInfoTitleEn(e.target.value)}
													/>
												</div>
												<div className="col-md-12 mt-4">
													<label htmlFor="question">وصف الخطوة</label>
													<textarea
														id="question"
														value={infoDescriptionEn}
														onChange={e => setInfoDescriptionEn(e.target.value)}
													/>
												</div>
											</div>
										</div>
										<div className="form-item" />
										<button
											className="bt bt-success"
											onClick={pushToInformationEn}
										>
											اضافة الخطوة
										</button>
										<div className="form-item" style={{ marginTop: "40px" }}>
											<ul className="list-unstyled pointList">
												{allInformationEn.map(feature => (
													<li key={feature.title}>
														<button onClick={e => handleDeleteInfoEn(e, feature)}>
															<i className="fas fa-trash" />
														</button>
														<span>
															<strong>{feature.title}</strong> -{" "}
															{feature.description}
														</span>
													</li>
												))}
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-12">
								<div className="form-item mt-3">
									<button className="bt bt-success btn-block">ارسال</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default About;